var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":".25","d":"M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4","key":0}),React.createElement("path",{"d":"M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z","key":1},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","from":"0 16 16","to":"360 16 16","dur":"0.8s","repeatCount":"indefinite"}))]);
}

Loader.defaultProps = {"viewBox":"0 0 32 32","width":"32","height":"32","fill":"white"};

module.exports = Loader;

Loader.default = Loader;
